/* eslint-disable react/prop-types */
import { Box, Button, Modal } from "@mui/material";
import React from "react";
import { DateRange } from "react-date-range";

function DateRangeFilter({ open, onClose, dateRange, onChange, onApply }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={
        {
          // zIndex: 9999,
        }
      }
    >
      <Box
        sx={{
          position: "absolute",
          top: "45%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 380,
          bgcolor: "#fff",
          border: "none",
          boxShadow: "0px 3px 25px #00000080",
          borderRadius: "5px",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#0077B6",
            }}
          >
            Date Filter
          </div>
          <div
            style={{
              display: "flex",
              gap: "15px",
            }}
          >
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{
                textTransform: "none",
                p: "3px 20px",
                backgroundColor: "#fff",
                color: "#0077B6",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                textTransform: "none",
                p: "3px 20px",
                backgroundColor: "#0077B6",
                color: "#fff",
              }}
              onClick={onApply}
            >
              Apply
            </Button>
          </div>
        </div>
        <DateRange
          ranges={[
            {
              ...dateRange[0],
              startDate:
                dateRange[0]?.startDate === null
                  ? new Date()
                  : dateRange[0]?.startDate,
              endDate:
                dateRange[0]?.endDate === null
                  ? new Date()
                  : dateRange[0]?.endDate,
            },
          ]}
          onChange={(e) => onChange([e.selection])}
          maxDate={new Date(new Date().getFullYear(), 11, 31)}
        />
      </Box>
    </Modal>
  );
}

export default DateRangeFilter;
